import apiHeader from "@/helpers/apiHeader";

const dashboardService = {
  get(params) {
    return apiHeader.get("dashboard", { params });
  },
  generate(year) {
    return apiHeader.get("dashboard/generate", { params: { year } });
  },
};

export default dashboardService;